<style scoped>
/* @import 'https://unpkg.com/highcharts/css/highcharts.css'; */
input.highcharts-range-selector {
    background-color: rgb(255, 255, 255) !important;
}
</style>

<template>
    <div id="container">
        <highcharts v-if="currOptions && chartData" :constructor-type="currType" class="hc" :options="currOptions" ref="highcharts"></highcharts>
    </div>
</template>

<script>
import moment from "moment";
import "moment-timezone";
import { dataA, dataB, dataC } from "Store/modules/test/chart_data";
import Highcharts from "highcharts";
import stockInit from "highcharts/modules/stock";
import bulletInit from "highcharts/modules/bullet";
import ganttInit from "highcharts/modules/gantt";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);

stockInit(Highcharts);
bulletInit(Highcharts);
ganttInit(Highcharts);

window.moment = moment;

// Update disabled status of the remove button, depending on whether or not we
// have any selected points.
function updateRemoveButtonStatus() {
    const chart = this.series.chart;
    // Run in a timeout to allow the select to update
}

export default {
    props: ["chartType", "chartData", "height"],
    data() {
        return {
            now: null,
            startOfDay: null,
            todays_year: "",
            todays_month: "",
            todays_day: "",
        };
    },
    mounted() {
        // window.moment = Moment
        // Highcharts.setOptions({
        //     time: {
        //         timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        //     }
        // });
        // console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)
        this.todays_day = +this.current_day.split("-")[2];
        this.todays_month = +this.current_day.split("-")[1] - 1;
        this.todays_year = +this.current_day.split("-")[0];
        this.now = new Date();
        let startOfDay = new Date(this.now.getFullYear(), this.now.getMonth(), this.now.getDate(), 8);
        this.startOfDay = startOfDay.getTime();
        this.$nextTick(() => {
            if (this.$refs.highcharts && this.chartType && this.chartData) this.$refs.highcharts.chart.reflow();
        });
    },
    computed: {
        current_time() {
            return new Date().getTime();
        },
        currOptions() {
            let options = {};
            if (this.chartType && this.chartData) {
                if (this.chartType == "stock") {
                    options = this.stockOptions;
                } else if (this.chartType == "bullet") {
                    options = this.bulletOptions;
                } else if (this.chartType == "gantt") {
                    options = this.ganttOptions;
                }
            }
            return options;
        },
        currType() {
            let type = "stockChart";
            if (this.chartType) {
                if (this.chartType == "stock") {
                    type = "stockChart";
                } else if (this.chartType == "bullet") {
                    type = "chart";
                } else if (this.chartType == "gantt") {
                    type = "ganttChart";
                }
            }
            return type;
        },
        bulletOptions() {
            return this.chartData && this.chartType == "bullet"
                ? {
                      chart: {
                          plotBorderColor: "#000",
                          plotBorderWidth: 1,
                          height: this.height ? this.height : "80",
                          inverted: true,
                          type: "bullet",
                      },
                      title: {
                          text: null,
                      },
                      legend: {
                          enabled: false,
                      },
                      credits: {
                          enabled: true,
                      },
                      xAxis: {
                          opposite: true,
                          categories: [`<b>${Math.round(+this.chartData.total_gallons_capacity * 100 * 100) / 100}</b>`],
                          lineColor: "#000",
                          lineWidth: 1,
                      },
                      yAxis: {
                          gridLineColor: "#666",
                          max: +this.chartData.total_gallons_capacity * 100,
                          endOnTick: false,
                          plotBands: [
                              {
                                  from: 0,
                                  to: +this.chartData.reorder_red * 100,
                                  color: "rgba(228, 0, 1, 0.5)",
                              },
                              {
                                  from: +this.chartData.reorder_red * 100,
                                  to: +this.chartData.reorder_yellow * 100,
                                  color: "rgba(255, 204, 0, 0.5)",
                              },
                              {
                                  from: +this.chartData.reorder_yellow * 100,
                                  to: +this.chartData.total_gallons_capacity * 100,
                                  color: "#bbb",
                              },
                          ],
                          labels: {
                              format: "{value}",
                          },
                          title: null,
                      },
                      plotOptions: {
                          series: {
                              pointPadding: 0.25,
                              borderWidth: 0,
                              color: "#000",
                              targetOptions: {
                                  width: "200%",
                              },
                              dataLabels: {
                                  enabled: true,
                                  align: "right",
                                  color: "#FFFFFF",
                                  x: -10,
                                  format: "{y} g",
                              },
                          },
                      },
                      series: [
                          {
                              data: [
                                  {
                                      y: +this.chartData.fill_volume_gallons * 100,
                                      target: +this.chartData.fill_volume_gallons * 100,
                                      pointWidth: 29,
                                  },
                              ],
                          },
                      ],
                      tooltip: {
                          pointFormat: "<b>{point.y} gallons</b>",
                      },
                  }
                : {};
        },
        stockOptions() {
            return this.chartData && this.chartType == "stock"
                ? {
                      tooltip: {
                          pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
                          valueDecimals: 2,
                          shared: true,
                          split: false,
                      },
                      navigator: {
                          adaptToUpdatedData: false,
                          margin: 60,
                      },
                      plotOptions: {
                          series: {
                              showInNavigator: true,
                          },
                      },
                      scrollbar: {
                          liveRedraw: false,
                      },
                      series: [
                          // { name: 'MSFT', data: dataA },
                          // { name: 'AAPL', data: dataB },
                          // { name: 'GOOG', data: dataC },
                          { name: "Signal", data: this.chartData ? this.chartData : [] },
                      ],
                      // Enable for x-axis
                      xAxis: {
                          crosshair: true,
                      },
                      // Enable for y-axis
                      yAxis: {
                          crosshair: true,
                      },
                      rangeSelector: {
                          buttonTheme: {
                              // styles for the buttons
                              fill: "none",
                              stroke: "none",
                              "stroke-width": 0,
                              r: 8,
                              style: {
                                  color: "#039",
                                  fontWeight: "bold",
                              },
                              states: {
                                  hover: {},
                                  select: {
                                      fill: "#039",
                                      style: {
                                          color: "white",
                                      },
                                  },
                                  // disabled: { ... }
                              },
                          },
                          // inputBoxBorderColor: 'gray',
                          inputBoxWidth: 100,
                          inputBoxHeight: 18,
                          inputStyle: {
                              color: "#039",
                              fontWeight: "bold",
                          },
                          labelStyle: {
                              color: "silver",
                              fontWeight: "bold",
                          },
                          floating: true,
                          y: -65,
                          verticalAlign: "bottom",
                          enabled: true,
                          allButtonsEnabled: true,
                          inputEnabled: true,
                          buttons: [
                              {
                                  type: "week",
                                  count: 1,
                                  text: "1w",
                                  title: "View 1 Week",
                              },
                              {
                                  type: "month",
                                  count: 1,
                                  text: "1m",
                                  title: "View 1 month",
                              },
                              {
                                  type: "ytd",
                                  text: "YTD",
                                  title: "View year to date",
                              },
                              {
                                  type: "year",
                                  count: 1,
                                  text: "1y",
                                  title: "View 1 year",
                              },
                              {
                                  type: "all",
                                  text: "All",
                                  title: "View all",
                              },
                          ],
                      },
                  }
                : {};
        },
        ganttOptions() {
            return this.chartData && this.chartType == "gantt"
                ? {
                      // colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4'],
                      colors: ["#50B432"],
                      time: {
                          timezone: "America/New_York",
                      },
                      accessibility: {
                          point: {
                              descriptionFormat:
                                  "{#if milestone}" +
                                  "{name}, milestone for {yCategory} at {x:%Y-%m-%d}." +
                                  "{else}" +
                                  "{name}, assigned to {yCategory} from {x:%Y-%m-%d} to " +
                                  "{x2:%Y-%m-%d}." +
                                  "{/if}",
                          },
                      },
                      credits: {
                          enabled: false,
                      },
                      customButtons: {
                          prevButton: {
                              icon: "chevron-left",
                              click: () => this.customButtonAction("prev"),
                          },
                          nextButton: {
                              icon: "chevron-right",
                              click: () => this.customButtonAction("next"),
                          },
                          todayButton: {
                              text: "today",
                              click: () => this.customButtonAction("today"),
                          },
                          datepickerButton: {
                              text: "select",
                              click: () => this.openDateSelect(),
                          },
                      },
                      plotOptions: {
                          series: {
                              animation: false, // Do not animate dependency connectors
                              dragDrop: {
                                  draggableX: true,
                                  draggableY: true,
                                  dragMinY: 0,
                                  dragMaxY: 2,
                                  dragPrecisionX: (1000 * 60 * 60 * 24) / 3, // Snap to eight hours
                              },
                              dataLabels: {
                                  enabled: true,
                                  format: "{point.name}",
                                  style: {
                                      cursor: "default",
                                      pointerEvents: "none",
                                  },
                              },
                              allowPointSelect: true,
                              point: {
                                  events: {
                                      select: updateRemoveButtonStatus,
                                      unselect: updateRemoveButtonStatus,
                                      remove: updateRemoveButtonStatus,
                                  },
                              },
                          },
                      },

                      // navigator: {
                      //     handles: {
                      //         height: 30
                      //     }
                      // },
                      xAxis: [
                          {
                              gridLineWidth: 1,
                              currentDateIndicator: {
                                  width: 1,
                                  dashStyle: "dot",
                                  color: "gray",
                                  label: {
                                      format: "%Y-%m-%d, %H:%M",
                                  },
                              },
                              type: "datetime",
                              tickInterval: 1000 * 60 * 60,
                              min: this.startOfDay,
                              max: this.startOfDay + 1000 * 60 * 60 * 34,
                              labels: {
                                  format: "{value:%k}", // hour
                              },
                              grid: {
                                  enabled: true,
                              },
                          },
                          {
                              labels: {
                                  format: "{value:%A, %B %e}",
                              },
                              tickInterval: 1000 * 60 * 60 * 24, // day
                          },
                      ],
                      yAxis: {
                          uniqueNames: true,
                          labels: {
                              events: {
                                  click: function (e) {
                                      console.log("click label", e);
                                      console.log(this);
                                  },
                              },
                              style: {
                                  cursor: "pointer",
                              },
                          },
                      },
                      navigator: {
                          enabled: false,
                          liveRedraw: true,
                          series: {
                              type: "gantt",
                              pointPlacement: 0.5,
                              pointPadding: 0.25,
                          },
                          yAxis: {
                              min: 0,
                              max: 3,
                              reversed: true,
                              categories: [],
                          },
                      },
                      scrollbar: {
                          enabled: false,
                      },
                      rangeSelector: {
                          inputEnabled: false,
                          enabled: true,
                          buttons: [
                              {
                                  type: "hour",
                                  count: 1,
                                  text: "1h",
                                  title: "View 1 hour",
                              },
                              {
                                  type: "day",
                                  count: 1,
                                  text: "1d",
                                  title: "View 1 day",
                              },
                              {
                                  type: "all",
                                  text: "All",
                                  title: "View all",
                              },
                          ],
                      },

                      series: [
                          {
                              name: "Project 1",
                              dataLabels: {
                                  enabled: true,
                                  align: "center",
                                  color: "#FFFFFF",
                                  format: "{point.value}",
                                  y: 1,
                                  style: {
                                      fontSize: "14px",
                                      height: "100%",
                                  },
                              },

                              data: [
                                  {
                                      start: Date.UTC(2022, this.todays_month, this.todays_day, 13),
                                      end: Date.UTC(2022, this.todays_month, this.todays_day, 16),
                                      name: "Furnace 1",
                                      value: "&#10003; Batch 1<br>Test",
                                      y: 0,
                                  },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 16),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 19),
                                  //       name: "Furnace 1",
                                  //       value: "&#10003; Batch 2",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 19),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 1),
                                  //       name: "Furnace 1",
                                  //       value: "&#10003; Batch 3",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 1),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 6),
                                  //       name: "Furnace 1",
                                  //       value: "Batch 4",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 6),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 12),
                                  //       name: "Furnace 1",
                                  //       value: "Batch 5",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 7),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 13),
                                  //       name: "Furnace 1",
                                  //       value: "Batch 99",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 13),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 18),
                                  //       completed:
                                  //           (this.current_time - Date.UTC(2022, this.todays_month, this.todays_day, 13)) /
                                  //           (Date.UTC(2022, this.todays_month, this.todays_day, 18) - Date.UTC(2022, this.todays_month, this.todays_day, 13)),
                                  //       name: "Furnace 2",
                                  //       value: "&#10003; Batch 1",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 18),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 24),
                                  //       name: "Furnace 2",
                                  //       value: "&#10003; Batch 2",
                                  //       color: "#e69138",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 24),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 3),
                                  //       name: "Furnace 2",
                                  //       value: "&#10003; Batch 3",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 3),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 6),
                                  //       name: "Furnace 2",
                                  //       value: "Batch 4",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 6),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 11),
                                  //       name: "Furnace 2",
                                  //       value: "Batch 5",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 11),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 16),
                                  //       name: "Furnace 2",
                                  //       value: "Batch 6",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 16),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 20),
                                  //       name: "Furnace 2",
                                  //       value: "Batch 7",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 13),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 16),
                                  //       name: "Furnace 3",
                                  //       value: "&#10003; Batch 1",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 16),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 19, 30),
                                  //       name: "Furnace 3",
                                  //       value: "&#10003; Batch 2",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 19, 30),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 24),
                                  //       name: "Furnace 3",
                                  //       value: "&#10003; Batch 3",
                                  //       color: "#A36DF7",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 24),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 4),
                                  //       name: "Furnace 3",
                                  //       value: "Batch 4",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 4),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 8),
                                  //       name: "Furnace 3",
                                  //       value: "Batch 5",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 8, 30),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 14),
                                  //       name: "Furnace 3",
                                  //       value: "Batch 6",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 14),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 20),
                                  //       name: "Furnace 3",
                                  //       value: "Batch 7",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 13),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 18, 30),
                                  //       name: "Furnace 4",
                                  //       value: "&#10003; Batch 1",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 18, 30),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 23),
                                  //       name: "Furnace 4",
                                  //       value: "&#10003; Batch 2",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 23),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 4),
                                  //       name: "Furnace 4",
                                  //       value: "&#10003; Batch 3",
                                  //       color: "#A36DF7",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 4),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 8),
                                  //       name: "Furnace 4",
                                  //       value: "Batch 4",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 8),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 12),
                                  //       name: "Furnace 4",
                                  //       value: "Batch 5",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 12),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 17),
                                  //       name: "Furnace 4",
                                  //       value: "Batch 6",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 13),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 18),
                                  //       name: "Furnace 5",
                                  //       value: "&#10003; Batch 1",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 18),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 22),
                                  //       name: "Furnace 5",
                                  //       value: "&#10003; Batch 2",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 22),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 3),
                                  //       name: "Furnace 5",
                                  //       value: "&#10003; Batch 3",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 3),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, this.todays_day + 1),
                                  //       name: "Furnace 5",
                                  //       value: "Batch 4",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, this.todays_day + 1),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 12),
                                  //       name: "Furnace 5",
                                  //       value: "Batch 5",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 13),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 17),
                                  //       name: "Furnace 6",
                                  //       value: "&#10003; Batch 1",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 18),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 24, 30),
                                  //       name: "Furnace 6",
                                  //       value: "&#10003; Batch 2",
                                  //       color: "#f44336",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 0, 30),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 5),
                                  //       name: "Furnace 6",
                                  //       value: "&#10003; Batch 3",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 5),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 9),
                                  //       name: "Furnace 6",
                                  //       value: "Batch 4",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 9),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 13),
                                  //       name: "Furnace 6",
                                  //       value: "Batch 5",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 13),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 18),
                                  //       name: "Furnace 6",
                                  //       value: "Batch 6",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 19),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 24),
                                  //       name: "Furnace 7",
                                  //       value: "&#10003; Batch 1",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 13),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 18),
                                  //       name: "Furnace 8",
                                  //       value: "&#10003; Batch 1",
                                  //       color: "#e69138",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 18),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 23),
                                  //       name: "Furnace 8",
                                  //       value: "&#10003; Batch 2",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 23),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 2),
                                  //       name: "Furnace 8",
                                  //       value: "&#10003; Batch 3",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 2),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 5),
                                  //       name: "Furnace 8",
                                  //       value: "Batch 4",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 5),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 11),
                                  //       name: "Furnace 8",
                                  //       value: "Batch 5",
                                  //       color: "#f44336",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 11),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 17),
                                  //       name: "Furnace 8",
                                  //       value: "Batch 6",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 17),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 21),
                                  //       name: "Furnace 8",
                                  //       value: "Batch 7",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 13),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 16),
                                  //       name: "Furnace 9",
                                  //       value: "&#10003; Batch 1",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 16),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 19),
                                  //       name: "Furnace 9",
                                  //       value: "&#10003; Batch 2",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 19),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 1),
                                  //       name: "Furnace 9",
                                  //       value: "&#10003; Batch 3",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 1),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 6),
                                  //       name: "Furnace 9",
                                  //       value: "Batch 4",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 6),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 12),
                                  //       name: "Furnace 9",
                                  //       value: "Batch 5",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 13),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 18, 30),
                                  //       name: "Furnace 10",
                                  //       value: "&#10003; Batch 1",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 18, 30),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day, 23),
                                  //       name: "Furnace 10",
                                  //       value: "&#10003; Batch 2",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day, 23),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 4),
                                  //       name: "Furnace 10",
                                  //       value: "&#10003; Batch 3",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 4),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 8),
                                  //       name: "Furnace 10",
                                  //       value: "Batch 4",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 8),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 12),
                                  //       name: "Furnace 10",
                                  //       value: "Batch 5",
                                  //   },
                                  //   {
                                  //       start: Date.UTC(2022, this.todays_month, this.todays_day + 1, 12),
                                  //       end: Date.UTC(2022, this.todays_month, this.todays_day + 1, 17),
                                  //       name: "Furnace 10",
                                  //       value: "Batch 6",
                                  //   },
                              ],
                          },
                      ],
                  }
                : {};
        },
    },
};
</script>
